var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 589,
    height: 281,
    viewBox: "0 0 589 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 208.5C0 208.5 69.078 168.609 339.751 159.5C545.455 152.577 578 0 578 0V208.5H0Z",
    fill: "#EDDFF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178 280.5C178 280.5 276.816 192.608 423.087 183.688C569.357 174.769 589 79.5 589 79.5V280.5H178Z",
    fill: "#EDDFF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardWave);
export default __webpack_public_path__ + "static/media/cardWave.de2deeede1ea8e25d0ff7d6d992d346c.svg";
export { ForwardRef as ReactComponent };